<template>
	<main id="rating">
		<form>
			<h2>{{currentSession.event && currentSession.event.name}}</h2>
			<i>{{prettyDate}}</i>
			<p><b>{{candidateInfos.name}}</b><br><i><span v-if="candidateInfos.startDate">Disponible le : {{candidateInfos.startDate}}</span><br>
			{{candidateInfos.mail}}</i></p>
			<h3>Appréciation :</h3>
			<span v-for="assement in assessments">
				<input type="radio" v-bind:value="assement.ref" v-bind:id="assement.ref" v-model="assessment" name="assessment">
				<label class="radio" v-bind:for="assement.ref" v-on:touchstart="forceFocus(assement.ref)">{{assement.label}}</label>
			</span>
			<div>
			<h3 v-if="mobilities.length > 0">Mobilité :</h3>
			<span v-for="mobility in mobilities">
				<input type="radio" v-bind:value="mobility.ref" v-bind:id="mobility.ref" v-model="mobility_model" name="mobility_model">
				<label class="radio mobility" v-bind:for="mobility.ref" v-on:touchstart="forceFocus(mobility.ref)" v-on:click="display_input(mobility.input_text)">{{mobility.label}}</label>
			</span>
			</div>
			<div id="mobility_region">
				<input type="text" id="region_text" placeholder="Nom de la région" v-model="mobility_text">
			</div>
			<h3 v-if="qualities.length > 0">Analyse :</h3>
			<ul class="rating">
				<li v-for="quality in qualities">
					<span>{{quality.label}}</span>
					<div class="stars" v-bind:id="quality.ref">
						<input v-bind:name="quality.ref" v-model="quality.value"  v-bind:id="quality.ref + '5'" value="5" type="radio">
						<label v-bind:for="quality.ref + '5'" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">
							<div class="star-o">★</div>
							<div class="star">★</div>
						</label>
						<input v-bind:name="quality.ref" v-model="quality.value" v-bind:id="quality.ref + '4'" value="4" type="radio">
						<label v-bind:for="quality.ref + '4'" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">
							<div class="star-o">★</div>
							<div class="star">★</div>
						</label>
						<input v-bind:name="quality.ref" v-model="quality.value" v-bind:id="quality.ref + '3'" value="3" type="radio">
						<label v-bind:for="quality.ref + '3'" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">
							<div class="star-o">★</div>
							<div class="star">★</div>
						</label>
						<input v-bind:name="quality.ref" v-model="quality.value"  v-bind:id="quality.ref + '2'" value="2" type="radio">
						<label v-bind:for="quality.ref + '2'" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">
							<div class="star-o">★</div>
							<div class="star">★</div>
						</label>
						<input v-bind:name="quality.ref" v-model="quality.value" checked="checked"  v-bind:id="quality.ref + '1'" value="1" type="radio">
						<label v-bind:for="quality.ref + '1'" v-on:touchstart="forceFocus" v-on:touchend="forceFocus">
							<div class="star-o">★</div>
							<div class="star">★</div>
						</label>
					</div>
				</li>
			</ul>
			<h3 v-if="textInputs.length > 0">Questions complémentaires :</h3>
			<div class="text_input" v-for="(params, key) in textInputs">
				<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
				<input type="text" v-bind:id="params.name" v-bind:placeholder="getLabel(params.label)" v-model="params.value" autocomplete="false" v-on:click="scrollToThisInput">
			</div>
			<h3>Remarques :</h3>
			<textarea v-model="note" placeholder="Remarques" v-on:click="scrollToThisInput" name="note"></textarea>
			<button  v-on:click.self.stop.prevent="validateForm()" v-bind:class="isActive ? 'selected' : ''">Sauvegarder</button>
			<div id="validate"></div>
		</form>
	</main>
</template>

<script>
import libs from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

export default{
	name: 'ratingTpl',
	data(){
		return{
			assessment : '',
			mobility_model : '',
			mobility_text : '',
			note : null,
			old_textInputs : []
		};
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	computed:{
		isActive : function() {
			if(!this.properties || !this.assessment.length) return false;
			if(!(this.properties.mobilities && this.properties.mobilities.length)) return true;
			var mobility_element = this.properties.mobilities.find(x => x.ref == this.mobility_model);
			if(!mobility_element) return false;
			if(mobility_element.input_text) return this.mobility_text.length;
			return true;
		},
		candidateInfos : function() {
			let infos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateTpl') > -1 && this.currentSession.stepsResults[e].firstName);
			if(!infos) infos = this.currentSession.stepsResults && Object.keys(this.currentSession.stepsResults).find(e => e.indexOf('candidateSelectionTpl') > -1 && this.currentSession.stepsResults[e].name);
			if(infos) infos = this.currentSession.stepsResults[infos];
			return {
				name : infos && ( infos.firstName ? (infos.firstName + ' ' + infos.lastName) : infos.name ),
				mail : infos && infos.mail,
				startDate : infos && infos.startDate && libs.prettyDate(this.lang, "digital", infos.startDate)
			};
		},
		prettyDate : function() {
			return libs.prettyDate(this.lang, 'text');
		},
		qualities : function() {
			if(this.properties && Array.isArray(this.properties.qualities) ){
				return this.properties.qualities.map( e => {return {label : e.label, ref : e.ref, value : 1 }});
			}
			return [];
		},
		assessments : function() {
			if(this.properties && Array.isArray(this.properties.assessments) ){
				return this.properties.assessments.map( e => {return {label : e.label, ref : e.ref}});
			}
			return [];
		},
		mobilities : function() {
			if(this.properties && Array.isArray(this.properties.mobilities) ){
				return this.properties.mobilities.map( e => {return {label : e.label, ref : e.ref, input_text: e.input_text}});
			}
			return [];
		},
		textInputs : function() {
			if(this.properties && Array.isArray(this.properties.textInputs) ){
				const oldInputs = this.old_textInputs;
				function getOldValue(element){
					if(!element.autoSave) return element.value || '';
					const equivalent = oldInputs.find(e => e.name === element.name);
					return equivalent && equivalent.value ? equivalent.value : element.value || '';
				}
				return this.properties.textInputs.map( e => {return {label : e.label, name : e.name, value : getOldValue(e), autoSave : e.autoSave || false}});
			}
			return [];
		}
	},
	methods:{
		validateForm : function(){
			var self = this;
			var button = document.getElementsByTagName("button")[0];
			var validate = document.getElementById("validate");
			if(!this.assessment.length) return;
			var out = {
				qualities: this.qualities,
				assessment: this.assessment,
				mobility: this.mobility_model,
				mobility_text : this.mobility_text,
				textInputs : this.textInputs
			};
			//Save necessary text fields
			if(out.textInputs && out.textInputs.length) {
				const toSave = out.textInputs.filter(e => e.autoSave);
				if(toSave.length){
					try{
						localStorage.setItem(this.$options.name + '_' + this.templateIndex, JSON.stringify({textInputs : toSave}));
					}catch(e){console.log(e);}
				}
			}
			if(typeof(this.note) == 'string' && this.note.trim().length) out.note = this.note.trim();

			let loader = new Promise(resolve => {
				validate.style.display = "block";
				button.classList.add("load");
				button.innerHTML = "";
				setTimeout(resolve, 1000);
			}).then(() => {
				button.classList.remove("load");
				button.classList.add("validate");
				validate.style.opacity = 1;
				return new Promise(resolve => setTimeout(resolve, 1000));
			}).then(() => {
				self.$emit('validateStep', self.$options.name, out);
			});
		},
		scrollToThisInput: function(event){
			return libs.scrollToElem(event.target);
		},
		forceFocus : function(event){
			let label = event.target && event.target.parentElement;
			if(!label || !label.htmlFor) return;
			let input = document.getElementById(label.htmlFor);
			if(!input || !input.click) return;
			input.click();
		},
		display_input : function(open){
			var input = document.getElementById("mobility_region");
			if(open) input.classList.add("display");
			else {
				input.classList.remove("display");
				this.mobility_text = '';
			}
		},
		getLabel : componentTools.getLabel
	},
	created : componentTools.created,
	mounted : function() {
		componentTools.mounted.call(this);
		//Restore auto saved text inputs
		const tplName = this.$options.name + '_' + this.templateIndex;
		let last_entries = localStorage.getItem(tplName);
		const textInputs = this.textInputs || [];
		if(last_entries && textInputs.length) {
			try{last_entries = JSON.parse(last_entries);}catch(e){console.log(e); last_entries = {}}
			if(last_entries.textInputs) this.old_textInputs = last_entries.textInputs;
		}
	}
};
</script>

<style lang="less">
@import '../assets/less/conf.import.less';
#rating textarea{
	overflow: hidden;
	resize: none;
	width: 100%;
	height: 8vh;
	min-height: 80px;
	font-size: 14px;
	padding: 1%;
	border-radius: 5px;
}
#rating input[type="radio"]{
	display: none;
}
#rating .radio{
	text-transform: uppercase;
	border-radius: 5px;
	font-size: 20px;
	border: 1px solid @cGrey;
	margin-left: 3%;
	display: inline-block;
	font-weight: bold;
	cursor: pointer;
}
#rating input[type="radio"]:checked{
	&+.radio{
		border: none;
		color: @cWhite;
	}
}
.rating input[type="radio"]{
	+ label{
		cursor: pointer;
		position: relative;
		float: right;
		font-size: 20px;
		.star{
			display: none;
			font-size: 28px;
		}
		.star-o{
			font-size: 28px;
			color: @cGrey_Light_3;
		}
		&:hover{
			.star, ~ label .star{
				display: inline;
			}
			.star-o, ~ label .star-o{
				display: none;
			}
		}
	}
	&:checked + label{
		.star, ~ label .star{
			display: inline;
		}
		.star-o, ~ label .star-o{
			display: none;
		}
	}
}
#rating .rating{
	text-align: left;
	li{
		display: inline-block;
		margin: 0;
		width: 49%;
		font-size: 0;
		span{
			display: inline-block;
			font-size: 12px;
			font-weight: bold;
			height: 34px;
			vertical-align: middle;
			width: 45%;
		}

		.stars {
			vertical-align: bottom;
			display: inline-block;
			width: 55%;
		}
	}
}
#rating #mobility_region {
	display: none;
	text-align: left;
	margin-top: 20px;
}
#rating #mobility_region.display {
	display: block;
}
#rating button{
	transition: 0.250s;
}
#rating button.load {
	background-color: transparent;
	box-shadow: none;
	border: 3px solid @cGrey_Light_3;
	cursor: wait;
	padding: 0;
	border-radius: 40px;
	width: 40px;
	height: 40px;
  	animation: rotating 1s 0.25s linear infinite;
  	&:active{
  		position: relative;
  		top: 0;
  	}
  	div{
		opacity: 0;
	}
}
#rating button.validate {
	background-color: transparent;
	box-shadow: none;
	transition: 0.5s;
	padding: 0;
	width: 40px;
  	animation: rotating 1s 0.25s linear infinite;
	position: relative;
	height: 40px;
}
#rating #validate {
	position: relative;
	top: -21px;
	left: 50%;
	display: none;
	width: 50px;
	transition: 0.5s;
	opacity: 0;
	margin-left: -25px;
	&:after{
		content: "";
		display: block;
		position: relative;
		left: 28%;
		transform: rotate(45deg);
		width: 10px;
		height: 4px;
		top: -2px;
		border-radius: 20px;
	}
	&:before {
		content: "";
		display: block;
		position: relative;
		border-radius: 20px;
		height: 4px;
		width: 20px;
		left: 36%;
		transform: rotate(-42deg);

	}
}
.text_input {
	margin-top : 10px;
}
@keyframes rotating {
	from {
		transform: rotate(0deg);
	}
	to {
	transform: rotate(360deg);
	}
}
// Computer
@media screen
and (min-width: 1025px){
	#rating .radio{
		padding: 20px 25px;
	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
// Small computer
@media screen
and (max-width: 1024px)
and (min-width: 769px){
	#rating .radio{
		padding: 15px 20px;
	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
// Tablet
@media screen
and (max-width: 768px)
and (min-width: 481px){
	#rating .radio{
		padding: 15px 20px;

	}
	#rating .rating{
		li{
			&:nth-of-type(2n){
				margin-left: 2%;
			}
		}
	}
}
//  Tablet and smartphone
@media screen
and (max-width: 741px){
	#rating .rating{
		li{
			display: block;
			width: 100%;
			text-align: left;
			span{
				min-width: 120px;
			}
			&:nth-of-type(2n){
				margin-left: 0;
			}
		}
	}
}
// Smartphone
@media screen
and (max-width: 480px){
	#rating .radio{
		padding: 15px 20px;
		&.mobility {
			display: block;
			width: fit-content;
			position: relative;
			left: 50%;
			transform: translateX(-50%);
			margin-bottom: 10px;
		}
	}
	#rating div span:last-of-type .mobility {
		margin-bottom: 0;
	}
	#rating .rating{
		li{
			margin-bottom: 10px;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/rating.vue